module.exports = __webpack_public_path__ + "static/index/img/baikal-204.30aca31f.jpg";